(() => {
  const initSection = (root) => {
    if (!root || root.dataset.storyReady) return;
    root.dataset.storyReady = 'true';
    const reveal = new IntersectionObserver((entries) => entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        reveal.unobserve(entry.target);
      }
    }), { threshold: 0.1 });
    root.querySelectorAll('.fitree-story-reveal').forEach((el) => reveal.observe(el));
    root.querySelectorAll('.fitree-story-feature').forEach((button) => button.addEventListener('click', () => {
      const open = button.classList.toggle('is-open');
      button.setAttribute('aria-expanded', String(open));
    }));
  };

  const initNavigation = () => {
    const nav = document.querySelector('.fitree-story-nav');
    if (!nav || nav.dataset.stickyReady) return;
    nav.dataset.stickyReady = 'true';
    const spacer = document.createElement('div');
    spacer.className = 'fitree-story-nav-spacer';
    spacer.setAttribute('aria-hidden', 'true');
    nav.after(spacer);
    const links = [...nav.querySelectorAll('a')];
    const sections = links.map((link) => document.querySelector(link.hash)).filter(Boolean);
    let navStart = nav.getBoundingClientRect().top + window.scrollY;

    const stickyHeaderBottom = () => {
      const header = document.querySelector('header-component, #shopify-section-header, .shopify-section-header-sticky');
      if (!header) return 0;
      const rect = header.getBoundingClientRect();
      return rect.bottom > 0 && rect.top <= 0 ? Math.max(0, rect.bottom) : 0;
    };

    const update = () => {
      const top = stickyHeaderBottom();
      const lastSection = sections[sections.length - 1];
      const storyEnd = lastSection ? lastSection.getBoundingClientRect().bottom + window.scrollY : Infinity;
      const fixed = window.scrollY + top >= navStart && window.scrollY + top < storyEnd - nav.offsetHeight;
      nav.style.setProperty('--fs-fixed-top', `${top}px`);
      nav.classList.toggle('is-fixed', fixed);
      spacer.style.height = fixed ? `${nav.offsetHeight}px` : '0px';

      let active = sections[0]?.id;
      sections.forEach((section) => {
        if (section.getBoundingClientRect().top < window.innerHeight * 0.42) active = section.id;
      });
      links.forEach((link) => link.classList.toggle('is-active', link.hash === `#${active}`));
    };

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', () => {
      if (!nav.classList.contains('is-fixed')) navStart = nav.getBoundingClientRect().top + window.scrollY;
      update();
    });
    update();
  };

  document.querySelectorAll('.fitree-story-section').forEach(initSection);
  initNavigation();
  document.addEventListener('shopify:section:load', (event) => {
    initSection(event.target.querySelector('.fitree-story-section'));
    initNavigation();
  });
})();
